/**
 * 商城-订单-列表接口
 * @author： xuyd
 * @date：2024-10-01
 */
import request from "@/utils/request.js"

import {context} from '@/config/env.js'

const serviceModule = context.sunflower

export default {

  /**
   * 检索列表
   */
  searchOrderList: (params) => {
    return request.post(serviceModule + "/api1/mall/order/searchOrderList", params);
  },

}
